// extracted by mini-css-extract-plugin
export default {"pricePlansPriceForm":"style_pricePlansPriceForm__AM4ay","priceFormPlans":"style_priceFormPlans__c6GID"};